import { Button, Card } from "@chef/components";
import { sendIntercomMessage } from "@chef/helpers";

import { RaatassOptOutSection } from "../RaatassOptOutSection";

import { intl } from "./AccountPostalAreaClosed.Intl";

export const AccountPostalAreaClosed = () => {
  return (
    <>
      <div className="flex flex-col gap-6 col-span-full md:col-span-5">
        <Card>
          <div className="flex justify-between">
            <h2 className="text-xl">
              <strong>{intl.SUBSCRIPTION_STATUS}</strong>
            </h2>
            <p>
              <strong className="mb-1 p-1 px-1.5 text-white rounded-sm bg-error text-xs">
                {intl.STATUS}
              </strong>
            </p>
          </div>

          <div className="mt-3">
            <p>
              <strong>{intl.YOUR_SUBSCRIPTION_IS_CANCELLED}</strong>
            </p>
            <p>{intl.WE_NO_LONGER_DELIVER_TO_YOU}</p>
            <br />
            <p>{intl.IF_WE_DO_IN_THE_FUTURE}</p>
          </div>

          <Button
            onClick={() =>
              sendIntercomMessage({ prepopulatedMessage: "", subject: "" })
            }
            outlined
            className="mt-6 text-sm"
            tiny
          >
            {intl.CONTACT_CUSTOMER_SERVICE}
          </Button>
        </Card>
        <RaatassOptOutSection />
      </div>
    </>
  );
};
